<div class="button-container" [ngClass]="{disabled: disabled, large: subTitle.length >0}">
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 132.99 122.66">
    <g style="isolation:isolate">
      <g id="ff2f2217-fd98-4b7e-926e-5f3997bcb290" data-name="Layer 2">
        <g id="f7e71c89-ca7d-4d5d-91a2-17ca86aaca8b" data-name="button_start">
          <g id="b47f5c32-4544-44bb-a937-968af256bb68" data-name="button_start_up">
            <g style="mix-blend-mode:multiply;opacity:0.199996992945671">
              <path
                d="M.31,50.79l49.1-7.26L46.64,26.61a8.68,8.68,0,0,1-9.29-7.67,6.66,6.66,0,0,1,0-.77,2.44,2.44,0,0,1,0-.27c0-.17,0-.33,0-.49a3.11,3.11,0,0,1,0-.32c0-.14,0-.28.08-.42s0-.23.07-.34.06-.18.08-.26c.09-.29.19-.58.3-.86a1,1,0,0,0,.07-.15,4.44,4.44,0,0,1,.24-.49l.06-.13.29-.49a9.18,9.18,0,0,1,7-4.12c5-.4,9.26,3,9.64,7.65a8.36,8.36,0,0,1-4.13,7.78h0l-.73.4-.09,0c-.23.11-.46.22-.7.31l-.21.07-.62.2-.12,0,2.77,16.92,49.5-7.32,26.26,18.7L107.85,80.05,58.61,87.33l6.77,35.33h-2l-6.72-35L7.25,94.92Z" />
            </g>
            <polygon points="15.29 83.69 109.93 77.08 127.44 56.23 107.2 38.03 12.56 44.64 15.29 83.69"
              style="fill:#e8ad09" />
            <path d="M8.29,40.93l3.29,47L111.9,81,133,55.85,108.62,33.92Z" style="fill:#fff" />
            <polygon points="15.29 83.69 109.93 77.08 127.44 56.23 107.2 38.03 12.56 44.64 15.29 83.69"
              style="fill:#fb0" />
            <g style="mix-blend-mode:multiply">
              <path d="M52.94,78.85l7.62.62,7.15-2.09L64.78,45.1s-.44-.07-6,0a67,67,0,0,0-7.59.4Z" style="fill:#ccc" />
            </g>
            <g style="opacity:0.5">
              <rect x="58.04" y="37.34" width="2" height="47.28" transform="translate(-4.42 4.62) rotate(-4.32)" />
            </g>
            <polygon points="55.23 10.68 64.18 122.66 66.16 122.66 57.23 10.53 55.23 10.68" style="fill:#ccc" />
            <polygon points="56.12 10.63 65.05 122.66 65.8 122.66 56.87 10.57 56.12 10.63" style="fill:#fff" />
            <path d="M52.94,78.85s1.78-1,7.73-1.49,7,.17,7,.17L65.38,45.1s-1.24,1.2-6.66.89l-7.78-.45Z"
              style="fill:#f5d98e" />
            <path d="M60.67,77.36a29.9,29.9,0,0,1,6-.07c.81.1,2.88.24,2.88.24L66.26,45c-3.64,0-4.28,1.16-7.54,1Z"
              style="fill:#e8ad09" />
            <path d="M47.35,10.6a8.88,8.88,0,1,0,8.88-8.88,8.88,8.88,0,0,0-8.88,8.88" style="fill:#5fb8de" />
            <path d="M65.11,10.6a8.88,8.88,0,1,1-8.88-8.88,8.89,8.89,0,0,1,8.88,8.88" style="fill:#27a4a8" />
            <path
              d="M63.46,5.46a10.43,10.43,0,0,1,.16,1.78A10.26,10.26,0,0,1,53.36,17.5,10.07,10.07,0,0,1,50,16.93,8.87,8.87,0,0,0,63.46,5.46"
              style="fill:#1b7375" />
            <path d="M56.23,7.24a2.87,2.87,0,1,1-2.87-2.86,2.86,2.86,0,0,1,2.87,2.86" style="fill:#bae2e3" />
          </g>
          <g id="b9b036dd-6319-4d1b-9d1e-be8a8a1d6d77" data-name="button_start_down">
            <g style="mix-blend-mode:multiply;opacity:0.199996992945671">
              <path
                d="M0,49.22l49.77-7.36L47,24.7a8.8,8.8,0,0,1-9.43-7.76c0-.27,0-.53,0-.79a2.45,2.45,0,0,1,0-.27c0-.17,0-.34,0-.5s0-.22,0-.32.05-.28.08-.42,0-.24.07-.35a2.76,2.76,0,0,0,.08-.27,8.82,8.82,0,0,1,.31-.86.77.77,0,0,1,.07-.16c.07-.17.15-.33.23-.49l.07-.13c.1-.17.19-.34.3-.5A9.27,9.27,0,0,1,45.92,7.7c5-.41,9.39,3.06,9.77,7.75a8.45,8.45,0,0,1-4.18,7.89h0c-.24.14-.48.28-.74.4l-.08,0c-.24.11-.47.22-.72.31l-.21.07-.63.2-.11,0,2.8,17.16L102,34.14l26.62,19L109,78.88,59.1,86.26l6.17,36.4h-2l-6.16-36.1L7,94Z" />
            </g>
            <polygon points="13.19 84.9 108.72 73.84 125.49 51.93 104.15 34.42 8.62 45.48 13.19 84.9"
              style="fill:#e8ad09" />
            <path d="M4.13,41.92,9.62,89.4,110.89,77.67l20.2-26.39L105.4,30.2Z" style="fill:#fff" />
            <polygon points="13.19 84.9 108.72 73.84 125.49 51.93 104.15 34.42 8.62 45.48 13.19 84.9"
              style="fill:#bf8d00" />
            <g style="mix-blend-mode:multiply">
              <path d="M51.09,78.26s1.79-.41,7.79-1.19,7-.82,7-.82l-4.39-32.7s-.45-.06-6,.27a68.73,68.73,0,0,0-7.67.75Z"
                style="fill:#ccc" />
            </g>
            <g style="opacity:0.5">
              <rect x="55.43" y="35.92" width="2.03" height="47.93" transform="translate(-6.81 7.24) rotate(-6.92)" />
            </g>
            <polygon points="50.27 9.12 64.08 122.66 66.15 122.66 52.28 8.88 50.27 9.12" style="fill:#ccc" />
            <polygon points="51.17 9.03 64.99 122.66 65.76 122.66 51.92 8.94 51.17 9.03" style="fill:#fff" />
            <path d="M51.09,78.26s1.76-1.08,7.76-1.86,7.06-.15,7.06-.15L62.13,43.52s-1.21,1.27-6.7,1.2l-7.9-.1Z"
              style="fill:#d9a000" />
            <path d="M58.85,76.4a30.41,30.41,0,0,1,6-.35c.82.07,2.93.11,2.93.11L63,43.36c-3.69.17-4.28,1.38-7.59,1.36Z"
              style="fill:#ab7f06" />
            <path d="M42.28,9.41A9,9,0,1,0,50.86,0a9,9,0,0,0-8.58,9.4" style="fill:#5fb8de" />
            <path d="M60.26,9.41A9,9,0,1,1,51.68,0a9,9,0,0,1,8.58,9.4" style="fill:#27a4a8" />
            <path
              d="M58.83,4.13a10.83,10.83,0,0,1,.08,1.81,10.4,10.4,0,0,1-10.86,9.92,10.47,10.47,0,0,1-3.37-.74,9,9,0,0,0,14.15-11"
              style="fill:#1b7375" />
            <path d="M51.43,5.6a2.91,2.91,0,1,1-2.77-3,2.92,2.92,0,0,1,2.77,3" style="fill:#bae2e3" />
          </g>
        </g>
      </g>
    </g>
  </svg>
  <div class="button-caption"><span class="maintitle"><ng-content></ng-content></span><span class="subtitle" *ngIf="subTitle.length > 0">{{subTitle}}</span></div>
</div>
